import "./utils/axios";
import "./scss/index.scss";
import "react-loading-skeleton/dist/skeleton.css";

import { Buffer } from "buffer";
import ReactDOM from "react-dom/client";
import { Providers } from "./providers/providers.tsx";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

globalThis.Buffer = Buffer;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Providers />
);
